import { Link } from 'react-router-dom';
import { Seo } from '../lib/seo';
export function NotFoundPage() { 
    return <>
    <Seo title="Página não encontrada" description="A página solicitada não foi encontrada." path="/404" />
    <main className="not-found">
        <div>
            <span className="section-tag">404</span>
            <h1>Essa rota não existe.</h1>
            <p>Volte para o início e continue navegando pela A3GS Tec.</p>
            <Link className="btn btn-primary" to="/">
                Voltar ao início
            </Link>
        </div>
    </main>
</>; }
